module.exports = __webpack_public_path__ + "img/img1.73af08e2.svg";